import { useState, useEffect } from "react";
import AddUserModal from "../../components/AddUserModal";
import MultiSelectFilter from "../../components/MultiSelectFilter";
import { PlusIcon } from "@heroicons/react/20/solid";
import UserTable from "../../components/UserTable";
import { users } from "../../components/UserManagementData";
import { userService } from "../../services/userService";
import toast from "react-hot-toast";
import Filters from "../../components/MultiSelectFilter";
import { applicationService } from "../../services/applicationService";

function UserManagement({ permission }) {
  const [isUserModalOpen, setIsUserModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [allGradeList, setAllGradeLIst] = useState([])
  const [page, setPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(10)
  const [allApplicationList, setAllApplicationList] = useState([])
  const [allStatusList, setAllStatusList] = useState([])
  const [allApplicationListFilter, setAllApplicationListFilter] = useState([])



  const [selectedFiltersIds, setSelectedFiltersIds] = useState({
    roles: "",
    status: "",
  });

  const [selectedFilters, setSelectedFilters] = useState({
    roles: [],
    status: [],
  });

  // ✅ get users & addUser function from context

  const fetchUsers = async () => {
    try {
      let data = JSON.stringify({
        'page': page,
        'limit': pageLimit,
        'role': selectedFiltersIds?.roles ? selectedFiltersIds?.roles : null,
        'status': selectedFiltersIds?.status ? selectedFiltersIds?.status : null
      })
      let res = await userService.getAllUsers(data);

      console.log("Fetched users:", res.data.users);
      setUsers(res.data.users);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };



  useEffect(() => {
    fetchUsers();
  }, [page, pageLimit, selectedFiltersIds?.roles, selectedFiltersIds?.status])

  // ✅ Handle add user form submission
  const handleAddUser = async (values) => {

    console.log("Adding user with values:", values);

    try {
      await userService.addUser(values);
      setIsUserModalOpen(false);
      fetchUsers(); // Refresh the user list after adding
    } catch (error) {
      console.error("Error adding user:", error);
    }
  };

  const filterConfigs = [
    { key: "roles", label: "All Roles", options: allApplicationListFilter, color: "blue" },
    // { key: "grades", label: "All Grades", options: allGradeList, color: "green" },
    { key: "status", label: "All Status", options: allStatusList, color: "purple" },
    // { key: "adoption", label: "All Adoption Levels", options: [{ id: "1", name: "Low" }, { id: "2", name: "Medium" }, { id: "2", name: "High" }], color: "orange" },
  ];


  async function getAllGradeData() {
    try {
      const response = await applicationService.getAllGrades()
      if (response?.success == true) {
        setAllGradeLIst(response?.data)
      } else {
        setAllGradeLIst([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }

  async function getAllApplicationForFilter() {
    try {
      let response = await userService.getAllRoles();
      // if (response?.success == true) {

      console.log(response, 'djhbbfjsdhbhjds')
      setAllApplicationListFilter(response?.data)

    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }

  async function getAllApplicationStatusForFilter() {
    try {
      const response = await applicationService.getAllApplicationStatusForFilter()
      if (response?.success == true) {
        setAllStatusList(response?.data)
      } else {
        setAllStatusList([])
      }
    } catch (e) {
      console.error('Error fetching data:', e)
    }
  }
  useEffect(() => {
    getAllGradeData()
    getAllApplicationForFilter()
    getAllApplicationStatusForFilter()
  }, [])
  return (
    <>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">User Management</h1>
        </div>

        <div className="flex items-center justify-between p-4">
          <div>
            {/* <h1 className="text-2xl font-bold text-gray-900">Applications</h1> */}
            {/* <p className="text-gray-600">Browse and access your learning applications</p> */}

            {/* <MultiSelectFilter /> */}
            <Filters filterConfigs={filterConfigs} selectedFilters={selectedFilters} setSelectedFilters={setSelectedFilters} selectedFiltersIds={selectedFiltersIds} setSelectedFiltersIds={setSelectedFiltersIds} date='date' />

          </div>
          {/* <MultiSelectFilter /> */}
          {permission?.create === true &&
            <button
              onClick={() => setIsUserModalOpen(true)}
              className="bg-brandBlue text-white px-4 flex gap-2 py-2 rounded-lg hover:bg-brandBlue-600 transition"
            >
              <PlusIcon className="w-5 h-5 text-white" /> Add New User
            </button>
          }


        </div>

        <div className="card">
          <div className="card-body">
            {loading ? (
              <p>Loading users...</p>
            ) : (
              <UserTable users={users} handleAddUser={handleAddUser} permission={permission} />
            )}
          </div>
        </div>
      </div>

      {permission?.create === true &&
        <AddUserModal
          isOpen={isUserModalOpen}
          onClose={() => setIsUserModalOpen(false)}
          onSave={handleAddUser} // ✅ connect the API here
        />
      }
    </>
  );
}

export default UserManagement;
